import { createElement, memo, type ReactNode } from "react";
import { drawRoom, ROOM_VIEW, type RoomScene, type Shape } from "@unfaithful/shared";

const camel = (k: string) => k.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());

function render(shape: Shape, key: number): ReactNode {
  const props: Record<string, unknown> = { key };
  for (const [k, v] of Object.entries(shape.attrs)) props[camel(k)] = v;
  return createElement(shape.tag, props, shape.children?.map(render));
}

const Shapes = memo(function Shapes({ scene }: { scene: RoomScene }) {
  return <>{drawRoom(scene).map(render)}</>;
}, (a, b) => JSON.stringify(a.scene) === JSON.stringify(b.scene));

/** Spot the Change: the castle room, drawn, with anything else laid over it. */
export function RoomPicture({ scene, label, children }: { scene: RoomScene; label: string; children?: ReactNode }) {
  return (
    <svg className="room-picture" viewBox={`0 0 ${ROOM_VIEW.width} ${ROOM_VIEW.height}`} role="img" aria-label={label}>
      <Shapes scene={scene} />
      {children}
    </svg>
  );
}
